const _temp0 = require("./config/25madison.json");
const _temp1 = require("./config/alon.json");
const _temp2 = require("./config/app.json");
const _temp3 = require("./config/app_test.json");
const _temp4 = require("./config/demo.json");
const _temp5 = require("./config/demo_3.json");
const _temp6 = require("./config/dev.json");
const _temp7 = require("./config/harvest.json");
const _temp8 = require("./config/odyssey.json");
const _temp9 = require("./config/stout.json");
const _temp10 = require("./config/stout_test.json");
const _temp11 = require("./config/test-env.json");
const _temp12 = require("./config/testing.json");
module.exports = {
  "25madison": _temp0,
  "alon": _temp1,
  "app": _temp2,
  "app_test": _temp3,
  "demo": _temp4,
  "demo_3": _temp5,
  "dev": _temp6,
  "harvest": _temp7,
  "odyssey": _temp8,
  "stout": _temp9,
  "stout_test": _temp10,
  "test-env": _temp11,
  "testing": _temp12
}